"use client";

import React from "react";
import LoginForm from "@components/auth/LoginForm";
import LoginPageContainer from "@components/page/PageContainer/LoginPageContainer";

const Login: React.FC = () => {
  return (
    <LoginPageContainer title="Log in to your account" subtitle="Welcome back!">
      <LoginForm />
    </LoginPageContainer>
  );
};

export default Login;
